import { AccountScopeProvider, AccountScopePage } from './context/AccountScope';
import isMobileLayout from './utils/isMobileLayout';
import { useEffect, useRef, useState } from 'react';
import Login from './pages/Login';

import socket, {
  conectarSocket,
  desconectarSocket
} from './services/socket';

import GoogleMapView from './components/GoogleMapView';
import HistoricalPlayback from './components/HistoricalPlayback';
import HistoricalPlaybackV2 from './components/HistoricalPlaybackV2';

import MonitoringLayout from './components/MonitoringLayout';
import Sidebar from './components/Sidebar';
import AdministrationPage from './pages/AdministrationPage';
import ConfigurationPage from './pages/ConfigurationPage';
import MyAccountPage from './pages/MyAccountPage';

import FolderTabsBar from './components/FolderTabsBar';
import VehicleDetail from './components/VehicleDetail';
import CentinelaPanel from './components/CentinelaPanel';
import ControlPanel from './components/ControlPanel';
import SplashScreen from './components/SplashScreen';
import {
  activarNotificacionesPush
} from './services/pushNotifications';

import NewModulePage
  from './components/NewModulePage';

function App() {
  const [isMobile, setIsMobile] = useState(isMobileLayout);
  const [mostrarSplash, setMostrarSplash] = useState(true);
  const [diviSesionLista, setDiviSesionLista] = useState(false);
  const [diviMapaListo, setDiviMapaListo] = useState(false);
  const [diviActivosListos, setDiviActivosListos] = useState(false);

useEffect(() => {
  const checkMobile = () => {
    setIsMobile(isMobileLayout());
  };

  checkMobile();

  window.addEventListener('resize', checkMobile);

  return () => {
    window.removeEventListener('resize', checkMobile);
  };
}, []);




  const [modoCrearGeocerca, setModoCrearGeocerca] =
  useState(false);

const [geocercaTemporal, setGeocercaTemporal] =
  useState(null);

const [geocercas, setGeocercas] =
  useState([]);

  const [geocercaSeleccionada, setGeocercaSeleccionada] =
  useState(null);
  const [logueado, setLogueado] = useState(false);

  const [
  mostrarActivacionPush,
  setMostrarActivacionPush
] = useState(false);

const [
  activandoPush,
  setActivandoPush
] = useState(false);

const [
  errorActivacionPush,
  setErrorActivacionPush
] = useState('');

useEffect(() => {
  if (!logueado) {
    return;
  }

  if (!('Notification' in window)) {
    return;
  }
  const current = JSON.parse(localStorage.getItem('user') || '{}');
  if (localStorage.getItem(`maccez:push-paused:${current.id}`) === '1') {
    setMostrarActivacionPush(false);
    return;
  }

  /*
    Si este dispositivo nunca ha decidido
    sobre las notificaciones, mostramos
    nuestro flujo de activación.

    NO llamamos requestPermission()
    automáticamente.
  */
  if (
    Notification.permission ===
    'default'
  ) {
    setMostrarActivacionPush(true);

    return;
  }

  setMostrarActivacionPush(false);

}, [logueado]);

async function activarPushDesdeUsuario() {
  try {
    setActivandoPush(true);

    setErrorActivacionPush('');

    await activarNotificacionesPush();
    const current = JSON.parse(localStorage.getItem('user') || '{}');
    localStorage.removeItem(`maccez:push-paused:${current.id}`);

    setMostrarActivacionPush(false);

  } catch (error) {
    console.error(
      'ERROR ACTIVANDO PUSH:',
      error
    );

    setErrorActivacionPush(
      error?.message ||
      'No fue posible activar las notificaciones'
    );

  } finally {
    setActivandoPush(false);
  }
}

  useEffect(() => {
  /*
    REASOCIACIÓN AUTOMÁTICA PUSH
  */
  if (!logueado) {
    return;
  }

  if (
    !('Notification' in window) ||
    Notification.permission !== 'granted'
  ) {
    return;
  }
  const current = JSON.parse(localStorage.getItem('user') || '{}');
  if (localStorage.getItem(`maccez:push-paused:${current.id}`) === '1') return;

  async function registrarPushUsuarioActual() {
    try {
      const resultado =
        await activarNotificacionesPush();

      console.log(
        'PUSH ASOCIADO AL USUARIO ACTUAL:',
        resultado?.success
      );

    } catch (error) {
      console.error(
        'ERROR ASOCIANDO PUSH AL LOGIN:',
        error.message
      );
    }
  }

  registrarPushUsuarioActual();

}, [logueado]);

  const [vehicles, setVehicles] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [devicesAdmin, setDevicesAdmin] = useState([]);
  const [sessionUserId, setSessionUserId] = useState(null);
  const [monitorUserId, setMonitorUserId] = useState(null);
  const [monitorAccounts, setMonitorAccounts] = useState([]);
  const [accountListRevision, setAccountListRevision] = useState(0);
  useEffect(() => {
    const refresh = () => setAccountListRevision(value => value + 1);
    window.addEventListener('maccez:profile-updated', refresh);
    return () => window.removeEventListener('maccez:profile-updated', refresh);
  }, []);
  const requestedScopeId = monitorUserId ?? sessionUserId;
  const scopeRef = useRef(null);
  scopeRef.current = requestedScopeId;

  const [
    vehiculoSeleccionado,
    setVehiculoSeleccionado
  ] = useState(null);

  const [
  seleccionUbicacionToken,
  setSeleccionUbicacionToken
] = useState(0);

const seleccionarVehiculoDesdeUI = (vehiculo) => {
  setVehiculoSeleccionado(vehiculo);

  if (vehiculo) {
    setSeleccionUbicacionToken(Date.now());
  }
};
  const [
  activoExpandido,
  setActivoExpandido
] = useState(false);

  const [
    historialRuta,
    setHistorialRuta
  ] = useState([]);
  const [
  detencionesHistoricas,
  setDetencionesHistoricas
] = useState([]);

  const [
    playbackIndex,
    setPlaybackIndex
  ] = useState(0);
const [playbackPosition, setPlaybackPosition] = useState(null);
const [playbackTravelledPath, setPlaybackTravelledPath] = useState([]);

  const [
    modoHistorico,
    setModoHistorico
  ] = useState(false);

  const [alertas, setAlertas] = useState([]);
  const [eventos] = useState([]);

  const [
    detalleVehiculoAbierto,
    setDetalleVehiculoAbierto
  ] = useState(false);

  const [
    menuAbierto,
    setMenuAbierto
  ] = useState(true);

  const [
    moduloActivo,
    setModuloActivo
  ] = useState('mapa');

  const [folderTabActiva, setFolderTabActiva] =
  useState(null);
  const [vistaGeocercas, setVistaGeocercas] =
  useState('geocercas');
  const [alertasCentinela, setAlertasCentinela] = useState([]);
const [detalleNotificacion, setDetalleNotificacion] =
  useState(null);

  const clearOperationalState = () => {
    setVehicles([]);
    setDevicesAdmin([]);
    setVehiculoSeleccionado(null);
    setActivoExpandido(false);
    setHistorialRuta([]);
    setDetencionesHistoricas([]);
    setPlaybackPosition(null);
    setPlaybackTravelledPath([]);
    setPlaybackIndex(0);
    setGeocercas([]);
    setGeocercaTemporal(null);
    setGeocercaSeleccionada(null);
    setModoCrearGeocerca(false);
    setModoHistorico(false);
    setModuloActivo('mapa');
    setFolderTabActiva(null);
    setAlertasCentinela([]);
    setAlertas([]);
    setDetalleNotificacion(null);
  };

  const changeMonitoringAccount = (userId) => {
    const ownId = Number(sessionUserId);
    const target = Number(userId);
    if (!Number.isSafeInteger(ownId) ||
        !monitorAccounts.some(account => Number(account.id) === target)) return;
    scopeRef.current = target;
    clearOperationalState();
    setMonitorUserId(target === ownId ? null : target);
  };

  useEffect(() => {
    if (!logueado) {
      scopeRef.current = null;
      setSessionUserId(null);
      setMonitorUserId(null);
      setMonitorAccounts([]);
      clearOperationalState();
      return;
    }
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setSessionUserId(Number(user.id) || null);
  }, [logueado]);

  useEffect(() => {
    if (!logueado || !sessionUserId) return;
    const controller = new AbortController();
    fetch('/api/monitoring/accounts', {
      signal: controller.signal,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(response => {
      if (!response.ok) throw new Error('Cuentas no disponibles');
      return response.json();
    }).then(data => {
      if (!controller.signal.aborted) setMonitorAccounts(data.accounts || []);
    }).catch(error => {
      if (error.name !== 'AbortError') console.error(error);
    });
    return () => controller.abort();
  }, [logueado, sessionUserId, accountListRevision]);

  useEffect(() => {
    if (!logueado || !requestedScopeId) return;
    const select = () => {
      socket.emit('monitoring:select', requestedScopeId, result => {
        if (Number(scopeRef.current) !== Number(requestedScopeId)) return;
        if (!result?.success) {
          scopeRef.current = Number(sessionUserId);
          clearOperationalState();
          setMonitorUserId(null);
        }
      });
    };
    socket.on('connect', select);
    if (socket.connected) select();
    return () => socket.off('connect', select);
  }, [logueado, requestedScopeId, sessionUserId]);

  useEffect(() => {
    const revoked = () => {
      scopeRef.current = Number(sessionUserId);
      clearOperationalState();
      setMonitorUserId(null);
    };
    socket.on('monitoring:revoked', revoked);
    return () => socket.off('monitoring:revoked', revoked);
  }, [sessionUserId]);

  useEffect(() => {
    if (!logueado || !sessionUserId || monitorUserId == null) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('centinela') === '1' ||
        params.get('notificacion') === 'ignicion') {
      changeMonitoringAccount(sessionUserId);
    }
  }, [logueado, sessionUserId, monitorUserId]);

  useEffect(() => {
  /*
    APERTURA DIRECTA DESDE PUSH CENTINELA

    Ejemplo recibido desde Service Worker:

    /?centinela=1&deviceId=13
  */

  if (!logueado) {
    return;
  }

  if (!Array.isArray(vehicles) || vehicles.length === 0) {
    return;
  }

  const params =
    new URLSearchParams(
      window.location.search
    );

  const abrirCentinela =
    params.get('centinela') === '1';

  const deviceId =
    params.get('deviceId');

  if (
    !abrirCentinela ||
    !deviceId
  ) {
    return;
  }

  /*
    Buscamos primero por el ID canónico
    MACCEZ.

    Como respaldo solamente para objetos
    cargados directamente desde /api/devices,
    usamos id cuando todavía no existe
    maccezVehicleId en ese objeto.
  */
  const vehiculoObjetivo =
    vehicles.find((vehicle) => {
      const maccezId =
        vehicle.maccezVehicleId ??
        vehicle.id;

      return (
        String(maccezId) ===
        String(deviceId)
      );
    });

  /*
    Todavía puede no haber llegado el
    vehículo por Socket.IO.

    En ese caso NO eliminamos los parámetros.
    El efecto volverá a ejecutarse cuando
    vehicles se actualice.
  */
  if (!vehiculoObjetivo) {
    return;
  }

  console.log(
    'CENTINELA PUSH - VEHICULO:',
    vehiculoObjetivo
  );

  /*
    Seleccionamos directamente
    el vehículo afectado.
  */
  setVehiculoSeleccionado(
    vehiculoObjetivo
  );

  /*
    Cerramos otros modos para que
    Centinela tenga el control de la UI.
  */
  setFolderTabActiva(null);

  setModoHistorico(false);

  setModoCrearGeocerca(false);

  setGeocercaTemporal(null);

  setGeocercaSeleccionada(null);

  /*
    Si existía la tarjeta roja interna,
    la retiramos porque el usuario ya
    está entrando a resolver la alerta.
  */
  setAlertasCentinela([]);

  /*
    Abrimos directamente Centinela.
  */
  setModuloActivo(
    'centinela'
  );

  /*
    Limpiamos los parámetros para evitar
    que un refresh vuelva a abrir la misma
    alerta una y otra vez.
  */
  const urlLimpia =
    window.location.pathname;

  window.history.replaceState(
    {},
    '',
    urlLimpia
  );

}, [
  logueado,
  vehicles
]);

useEffect(() => {
  if (!logueado || vehicles.length === 0) {
    return;
  }

  const params =
    new URLSearchParams(window.location.search);

  if (params.get('notificacion') !== 'ignicion') {
    return;
  }

  const deviceId = params.get('deviceId');
  const tipo = params.get('tipo');

  if (
    !deviceId ||
    ![
      'VEHICULO_ENCENDIDO',
      'VEHICULO_APAGADO'
    ].includes(tipo)
  ) {
    return;
  }

  const vehiculo = vehicles.find((item) =>
    String(item.maccezVehicleId ?? item.id) ===
    String(deviceId)
  );

  // Esperamos a que llegue el vehículo autorizado.
  if (!vehiculo) {
    return;
  }

  const fecha = new Date(
    params.get('momento') || ''
  );
let datosPush = {};

try {
  const fragmento = new URLSearchParams(
    window.location.hash.slice(1)
  );

  const detalle = fragmento.get('detalle');

  if (detalle) {
    datosPush = JSON.parse(detalle);
  }
} catch (error) {
  console.error(
    'No se pudo leer el detalle del push:',
    error
  );
}
  setVehiculoSeleccionado(vehiculo);
  setSeleccionUbicacionToken(Date.now());
  setModuloActivo('mapa');
  setFolderTabActiva(null);
  setModoHistorico(false);
  setActivoExpandido(false);

 setDetalleNotificacion({
  nombre: vehiculo.name || 'Vehículo',
  tipo,
  momento:
    Number.isNaN(fecha.getTime())
      ? null
      : fecha.toISOString(),
  mensaje:
    typeof datosPush.mensaje === 'string'
      ? datosPush.mensaje
      : '',
  lugar:
    typeof datosPush.lugar === 'string'
      ? datosPush.lugar
      : '',
  direccion:
    typeof datosPush.direccion === 'string'
      ? datosPush.direccion
      : '',
  ciudad:
    typeof datosPush.ciudad === 'string'
      ? datosPush.ciudad
      : ''
});

  window.history.replaceState(
    {},
    '',
    window.location.pathname
  );
}, [logueado, vehicles]);
  useEffect(() => {
    async function verificarSesion() {
      const token = localStorage.getItem('token');

      if (!token) {
        setDiviSesionLista(true);
        return;
      }

      try {
        const response = await fetch('/api/auth/me', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const data = await response.json();
if (data.success) {
  /*
    Conservamos los datos completos que ya
    tiene la sesión y actualizamos únicamente
    los campos recibidos por /auth/me.

    Así no perdemos name/email si /auth/me
    devuelve una sesión más resumida.
  */
  const usuarioGuardado =
    JSON.parse(
      localStorage.getItem('user') || '{}'
    );

  const usuarioSesion = {
    ...usuarioGuardado,
    ...data.user,

    name:
      data.user?.name ??
      usuarioGuardado.name,

    email:
      data.user?.email ??
      usuarioGuardado.email
  };

  localStorage.setItem(
    'user',
    JSON.stringify(usuarioSesion)
  );

  conectarSocket();

  setLogueado(true);
} else {
  desconectarSocket();

  localStorage.removeItem('token');
  localStorage.removeItem('user');

  setLogueado(false);
}
      } catch (error) {
        console.error('Error verificando sesión:', error);
        setLogueado(false);
      } finally {
        setDiviSesionLista(true);
      }
    }

    verificarSesion();
  }, []);
useEffect(() => {
  if (!logueado) {
    return;
  }

  conectarSocket();

  return () => {
    desconectarSocket();
  };
}, [logueado]);
useEffect(() => {
  if (!logueado) {
    return;
  }

  async function cargarUsuarios() {
    try {
      const token =
        localStorage.getItem('token');

      if (!token) return;

      const response =
        await fetch('/api/users', {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        });

      const data =
        await response.json();

      console.log(
        'USUARIOS:',
        data
      );

      if (Array.isArray(data)) {
        setUsuarios(data);
      }

      if (
        Array.isArray(data.users)
      ) {
        setUsuarios(data.users);
      }

    } catch (error) {
      console.error(
        'Error cargando usuarios:',
        error
      );
    }
  }

  cargarUsuarios();

}, [logueado]);

useEffect(() => {
  if (!logueado || !requestedScopeId) return;

  const controller = new AbortController();
  const scopeId = Number(requestedScopeId);
  setVehicles([]);
  setDevicesAdmin([]);
  setVehiculoSeleccionado(null);

  async function cargarDispositivos() {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const response = await fetch(
        `/api/devices?monitorUserId=${encodeURIComponent(scopeId)}`,
        {
          signal: controller.signal,
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (!response.ok) throw new Error('No se pudo cargar la cuenta');
      const data = await response.json();
      if (controller.signal.aborted || Number(scopeRef.current) !== scopeId) return;
      const devices = Array.isArray(data.devices) ? data.devices : [];
      setDevicesAdmin(devices);
      setVehicles(devices);
      setDiviActivosListos(true);
    } catch (error) {
      if (error.name !== 'AbortError') console.error('MONITOREO:', error);
    }
  }

  cargarDispositivos();
  return () => controller.abort();
}, [logueado, requestedScopeId]);


  useEffect(() => {
    socket.on('gps-update', (data) => {
      if (!Array.isArray(data?.vehicles) ||
          Number(data.scopeUserId) !== Number(scopeRef.current)) return;
      const scopedVehicles = data.vehicles;
      const enrichedVehicles = scopedVehicles.map((gps) => {
        const localDevice = devicesAdmin.find((device) =>
          Number(device.owner_user_id) === Number(gps.owner_user_id) &&
          String(device.imei || device.uniqueid || '') ===
          String(gps.imei || gps.uniqueid || gps.name || '')
        );

    return {
  ...gps,

  /*
    El nombre oficial del activo siempre
    viene de la base de datos MACCEZ.

    La telemetría no debe sobrescribirlo
    con el nombre antiguo de Traccar
    o de otra fuente realtime.
  */
  name:
    localDevice?.name ??
    gps.name,

  company_id:
    gps.company_id || localDevice?.company_id,
          company_name:
            gps.company_name || localDevice?.company_name,

          admin_id:
            gps.admin_id || localDevice?.admin_id,
          admin_name:
            gps.admin_name || localDevice?.admin_name,

          user_id:
            gps.user_id || localDevice?.user_id,
          user_name:
            gps.user_name || localDevice?.user_name,
          user_email:
  gps.user_email || localDevice?.user_email,

          owner_email: localDevice?.owner_email ?? gps.owner_email ?? null,
          first_online_at: localDevice?.first_online_at ?? gps.first_online_at ?? null,
          created_at: localDevice?.created_at ?? gps.created_at ?? null,
          plate: localDevice?.plate ?? gps.plate ?? null,

license_status:
  gps.licenseValid === true
    ? (new Date(gps.license_expires_at || localDevice?.license_expires_at).getTime() - Date.now() <= 30 * 86400000
      ? 'expiring' : 'active')
    : gps.licenseValid === false
      ? (gps.license_expires_at || localDevice?.license_expires_at ? 'expired' : 'unlicensed')
      : localDevice?.license_status || null,

license_expires_at:
  gps.license_expires_at || localDevice?.license_expires_at || null,

license_activated_at:
  localDevice?.license_activated_at || null
        };
      });

      console.log('VEHICLES ENRICHED:', enrichedVehicles);
      console.log('GPS RAW SAMPLE:', scopedVehicles[0]);

console.log(
  'DEVICE ADMIN SAMPLE:',
  devicesAdmin[0]
);

console.log(
  'ENRICHED SAMPLE:',
  enrichedVehicles[0]
);
setVehicles((prev) => {
  return enrichedVehicles.map((vehicle) => {
    const anterior = prev.find((v) => {
      if (Number(v.owner_user_id) !== Number(vehicle.owner_user_id)) return false;
      return (
        String(v.id) === String(vehicle.id) ||
        String(v.imei) === String(vehicle.imei) ||
        String(v.uniqueId) === String(vehicle.uniqueId) ||
        String(v.imei) === String(vehicle.uniqueId) ||
        String(v.uniqueId) === String(vehicle.imei)
      );
    });
if (vehicle.licenseValid === false) {
  return vehicle;
}
const tienePrioridadTeltonika =
  anterior?.source === 'teltonika-direct' ||
  anterior?.rawTeltonikaDirect?.source === 'teltonika-direct';

const tiempoTeltonika = new Date(
  anterior?.serverTime ||
  anterior?.lastSeen ||
  0
).getTime();

const tiempoTraccar = new Date(
  vehicle?.serverTime ||
  vehicle?.lastSeen ||
  0
).getTime();

if (
  tienePrioridadTeltonika &&
  tiempoTeltonika >= tiempoTraccar
) {
  return {
    ...vehicle,
    ...anterior,

    /*
      Los datos administrativos vienen de
      MACCEZ y siempre deben prevalecer
      sobre una copia realtime anterior.
    */
    name:
      vehicle.name ??
      anterior.name,

    company_id:
      vehicle.company_id ??
      anterior.company_id,

    company_name:
      vehicle.company_name ??
      anterior.company_name,

    admin_id:
      vehicle.admin_id ??
      anterior.admin_id,

    admin_name:
      vehicle.admin_name ??
      anterior.admin_name,

    user_id:
      vehicle.user_id ??
      anterior.user_id,

    user_name:
      vehicle.user_name ??
      anterior.user_name,

    user_email:
      vehicle.user_email ??
      anterior.user_email,

    owner_email: vehicle.owner_email ?? anterior.owner_email,
    first_online_at: vehicle.first_online_at ?? anterior.first_online_at,
    created_at: vehicle.created_at ?? anterior.created_at,
    plate: vehicle.plate ?? anterior.plate
  };
}

    return vehicle;
  });
});
      setVehiculoSeleccionado((actual) => {
  if (!actual) return actual;

const actualizado = enrichedVehicles.find((v) => {
  return (
    String(v.id) === String(actual.id) ||
    String(v.imei) === String(actual.imei) ||
    String(v.uniqueId) === String(actual.uniqueId) ||
    String(v.imei) === String(actual.uniqueId) ||
    String(v.uniqueId) === String(actual.imei)
  );
});

if (!actualizado) return null;
if (actualizado.licenseValid === false) {
  return actualizado;
}

const seleccionadoTeltonika =
  actual.source === 'teltonika-direct' ||
  actual.rawTeltonikaDirect?.source === 'teltonika-direct';
if (seleccionadoTeltonika) {
  return {
    ...actualizado,
    ...actual,

    /*
      El estado de Centinela viene del
      backend y debe tener prioridad
      sobre la copia local anterior.
    */
    centinelaActivo:
      actualizado.centinelaActivo,
    owner_email: actualizado.owner_email ?? actual.owner_email,
    first_online_at: actualizado.first_online_at ?? actual.first_online_at,
    created_at: actualizado.created_at ?? actual.created_at,
    plate: actualizado.plate ?? actual.plate
  };
}

return {
  ...actualizado,

  /*
    Siempre utilizamos el estado
    actualizado recibido del backend.
  */
  centinelaActivo:
    actualizado.centinelaActivo
};
});
    });
const handleTeltonikaUpdate = (payload) => {
  if (Number(payload.scopeUserId) !== Number(scopeRef.current)) return;


  console.log('[TELTONIKA FRONT PAYLOAD]', payload);
      setVehicles((prev) =>
  prev.map((vehicle) => {
    if (vehicle.licenseValid === false) return vehicle;

    const mismoImei =
            String(vehicle.imei || vehicle.uniqueId || '') ===
            String(payload.imei || '');

          if (!mismoImei) return vehicle;

          return {
            ...vehicle,

            source: payload.source,
            protocol: payload.protocol || 'teltonika',

            lat: payload.latitude ?? vehicle.lat,
            lng: payload.longitude ?? vehicle.lng,
            speed: payload.speed ?? vehicle.speed,

            ignition: payload.status?.ignition
              ? 'ENCENDIDO'
              : 'APAGADO',

            ignitionRaw:
              payload.status?.ignition ?? vehicle.ignitionRaw,

            motion: payload.status?.movement
              ? 'EN MOVIMIENTO'
              : 'DETENIDO',

            din1: payload.inputs?.din1 ?? vehicle.din1,
            din2: payload.inputs?.din2 ?? vehicle.din2,
            din3: payload.inputs?.din3 ?? vehicle.din3,

            din1Status:
              payload.inputs?.din1 === true ? 'ON' : 'OFF',
            din2Status:
              payload.inputs?.din2 === true ? 'ON' : 'OFF',
            din3Status:
              payload.inputs?.din3 === true ? 'ON' : 'OFF',

            dout1: payload.outputs?.dout1 ?? vehicle.dout1,
            dout2: payload.outputs?.dout2 ?? vehicle.dout2,
            dout3: payload.outputs?.dout3 ?? vehicle.dout3,

            power:
              payload.power?.externalVoltage ?? vehicle.power,

            battery:
              payload.power?.batteryVoltage ?? vehicle.battery,

            gsm:
              payload.network?.gsmSignal ?? vehicle.gsm,

            rssi:
              payload.network?.gsmSignal ?? vehicle.rssi,

            sat:
              payload.satellites ?? vehicle.sat,

            odometer:
              payload.odometer?.total ?? vehicle.odometer,

            totalDistance:
              payload.odometer?.total ?? vehicle.totalDistance,

            lastSeen:
              payload.lastServerUpdate ?? vehicle.lastSeen,

            serverTime:
              payload.lastServerUpdate ?? vehicle.serverTime,

            deviceTime:
              payload.lastGpsTimestamp ?? vehicle.deviceTime,

            fixTime:
              payload.lastGpsTimestamp ?? vehicle.fixTime,

            connectionStatus: 'ONLINE',

            rawTeltonikaDirect: payload
          };
        })
      );

      setVehiculoSeleccionado((actual) => {
       if (!actual || actual.licenseValid === false) return actual;

        const mismoImei =
          String(actual.imei || actual.uniqueId || '') ===
          String(payload.imei || '');

        if (!mismoImei) return actual;

        return {
          ...actual,

          source: payload.source,
          protocol: payload.protocol || 'teltonika',

          lat: payload.latitude ?? actual.lat,
          lng: payload.longitude ?? actual.lng,
          speed: payload.speed ?? actual.speed,

          ignition: payload.status?.ignition
            ? 'ENCENDIDO'
            : 'APAGADO',

          ignitionRaw:
            payload.status?.ignition ?? actual.ignitionRaw,

          motion: payload.status?.movement
            ? 'EN MOVIMIENTO'
            : 'DETENIDO',

          din1: payload.inputs?.din1 ?? actual.din1,
          din2: payload.inputs?.din2 ?? actual.din2,
          din3: payload.inputs?.din3 ?? actual.din3,

          din1Status:
            payload.inputs?.din1 === true ? 'ON' : 'OFF',
          din2Status:
            payload.inputs?.din2 === true ? 'ON' : 'OFF',
          din3Status:
            payload.inputs?.din3 === true ? 'ON' : 'OFF',
dout1:
  payload.outputs?.dout1 ?? actual.dout1,
dout2:
  payload.outputs?.dout2 ?? actual.dout2,
dout3:
  payload.outputs?.dout3 ?? actual.dout3,

dout1Status:
  payload.outputs?.dout1 === true
    ? 'ON'
    : payload.outputs?.dout1 === false
      ? 'OFF'
      : actual.dout1Status,

dout2Status:
  payload.outputs?.dout2 === true
    ? 'ON'
    : payload.outputs?.dout2 === false
      ? 'OFF'
      : actual.dout2Status,

dout3Status:
  payload.outputs?.dout3 === true
    ? 'ON'
    : payload.outputs?.dout3 === false
      ? 'OFF'
      : actual.dout3Status,
          power:
            payload.power?.externalVoltage ?? actual.power,

          battery:
            payload.power?.batteryVoltage ?? actual.battery,

          gsm:
            payload.network?.gsmSignal ?? actual.gsm,

          rssi:
            payload.network?.gsmSignal ?? actual.rssi,

          sat:
            payload.satellites ?? actual.sat,

          odometer:
            payload.odometer?.total ?? actual.odometer,

          totalDistance:
            payload.odometer?.total ?? actual.totalDistance,

          lastSeen:
            payload.lastServerUpdate ?? actual.lastSeen,

          serverTime:
            payload.lastServerUpdate ?? actual.serverTime,

          deviceTime:
            payload.lastGpsTimestamp ?? actual.deviceTime,

          fixTime:
            payload.lastGpsTimestamp ?? actual.fixTime,

          connectionStatus: 'ONLINE',

          rawTeltonikaDirect: payload
        };
      });
    };
    socket.on('teltonika:state:update', handleTeltonikaUpdate);
    socket.on('teltonika:state:change', handleTeltonikaUpdate);
    return () => {
     socket.off('gps-update');
      socket.off('teltonika:state:update', handleTeltonikaUpdate);
      socket.off('teltonika:state:change', handleTeltonikaUpdate);
    };
 
  }, [devicesAdmin]);

useEffect(() => {
  const receive = (alerta) => {
    if (!alerta || Number(alerta.recipientUserId || sessionUserId) !== Number(sessionUserId)) return;
    setAlertas(prev => [alerta, ...prev].slice(0, 50));
  };
  socket.on('vehicle-alert', receive);
  return () => socket.off('vehicle-alert', receive);
}, [sessionUserId]);

useEffect(() => {
  socket.on('centinela-alert', (alertas) => {
  
    console.log('ALERTAS CENTINELA FRONT:', alertas);

    setAlertasCentinela((prev) => [
      ...alertas,
      ...prev
    ]);
  });

  return () => {
    socket.off('centinela-alert');
  };
}, []);




const accountLink = new URLSearchParams(
  window.location.hash.slice(1)
);

if (
  !logueado ||
  accountLink.has('activar') ||
  accountLink.has('restablecer')
) {
  return (
    <>
      {mostrarSplash && (
        <SplashScreen key="divi-startup" ready={diviSesionLista}
          onComplete={() => setMostrarSplash(false)} />
      )}
      <Login setLogueado={setLogueado} />
    </>
  );
}

return (
<>
  {mostrarSplash && (
    <SplashScreen key="divi-startup" ready={diviSesionLista && diviMapaListo && diviActivosListos}
      onComplete={() => setMostrarSplash(false)} />
  )}
<div
 style={{
  display: 'flex',
  position: 'relative',

  width: '100%',
  height: '100vh',

  margin: 0,
  padding: 0,

  overflow: 'hidden'
}}
>

      {mostrarActivacionPush && (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 1000000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      boxSizing: 'border-box',
      background:
        'rgba(2, 12, 27, 0.72)',
      backdropFilter: 'blur(8px)'
    }}
  >
    <div
      style={{
        width: '100%',
        maxWidth: '360px',
        padding: '24px',
        boxSizing: 'border-box',
        borderRadius: '22px',
        background:
          'linear-gradient(145deg, #09254a, #061a34)',
        border:
          '1px solid rgba(255,255,255,0.14)',
        boxShadow:
          '0 22px 70px rgba(0,0,0,0.45)',
        color: '#ffffff',
        textAlign: 'center'
      }}
    >
      <div
        style={{
          fontSize: '34px',
          marginBottom: '10px'
        }}
      >
        🔔
      </div>

      <div
        style={{
          fontSize: '20px',
          fontWeight: 900
        }}
      >
        Activa las alertas
      </div>

      <div
        style={{
          marginTop: '10px',
          fontSize: '13px',
          lineHeight: '19px',
          color: '#cbd5e1'
        }}
      >
        MACCEZ TRACK necesita permiso
        para avisarte sobre ignición,
        seguridad y Centinela incluso
        cuando la aplicación está cerrada.
      </div>

      {errorActivacionPush && (
        <div
          style={{
            marginTop: '12px',
            color: '#fca5a5',
            fontSize: '12px',
            fontWeight: 700
          }}
        >
          {errorActivacionPush}
        </div>
      )}

      <button
        type="button"
        disabled={activandoPush}
        onClick={activarPushDesdeUsuario}
        style={{
          width: '100%',
          height: '46px',
          marginTop: '20px',
          border: 0,
          borderRadius: '13px',
          background: '#168df2',
          color: '#ffffff',
          fontSize: '14px',
          fontWeight: 900,
          cursor: 'pointer',
          opacity:
            activandoPush
              ? 0.65
              : 1
        }}
      >
        {activandoPush
          ? 'Activando...'
          : 'Activar notificaciones'}
      </button>
    </div>
  </div>
)}
 <Sidebar
  menuAbierto={menuAbierto}
  setMenuAbierto={setMenuAbierto}
  moduloActivo={moduloActivo}
  setModuloActivo={(nuevoModulo) => {
    setModuloActivo(nuevoModulo);

    if (nuevoModulo !== 'mapa') {
      setFolderTabActiva(null);
    }

    if (nuevoModulo !== 'historico') {
      setModoHistorico(false);
    }

    if (nuevoModulo !== 'mapa') {
      setModoCrearGeocerca(false);
      setGeocercaTemporal(null);
      setGeocercaSeleccionada(null);
    }
  }}
  vehiculos={vehicles}
vehiculoSeleccionado={vehiculoSeleccionado}
setVehiculoSeleccionado={seleccionarVehiculoDesdeUI}
/>

<div
  style={{
    flex: 1,
    position: 'relative',

    width: '100%',
    height: '100%',

    margin: 0,
    padding: isMobile
      ? '0'
      : '58px 0 0 0',

    boxSizing: 'border-box',
    overflow: 'hidden'
  }}
>
 <AccountScopeProvider accountId={requestedScopeId} accounts={monitorAccounts}>
 <MonitoringLayout
  monitorAccounts={monitorAccounts}
  sessionUserId={sessionUserId}
  selectedMonitorUserId={monitorUserId}
  onChangeMonitoring={changeMonitoringAccount}
  alertas={alertas}
  eventos={eventos}
  monitorUserId={requestedScopeId}
  vehicles={vehicles}
  usuarios={usuarios}

  geocercas={geocercas}
  setGeocercas={setGeocercas}
  modoCrearGeocerca={modoCrearGeocerca}
  setModoCrearGeocerca={setModoCrearGeocerca}
  geocercaTemporal={geocercaTemporal}
  setGeocercaTemporal={setGeocercaTemporal}
  geocercaSeleccionada={geocercaSeleccionada}
setGeocercaSeleccionada={setGeocercaSeleccionada}

  folderTabActiva={folderTabActiva}
  vistaGeocercas={vistaGeocercas}
setVistaGeocercas={setVistaGeocercas}
  setFolderTabActiva={setFolderTabActiva}
  vehiculoSeleccionado={vehiculoSeleccionado}
setVehiculoSeleccionado={seleccionarVehiculoDesdeUI}
activoExpandido={activoExpandido}
setActivoExpandido={setActivoExpandido}

  modoHistorico={modoHistorico}
  setModoHistorico={setModoHistorico}
  detalleVehiculoAbierto={detalleVehiculoAbierto}
  setDetalleVehiculoAbierto={setDetalleVehiculoAbierto}
  moduloActivo={moduloActivo}
  setModuloActivo={setModuloActivo}
/>
{isMobile &&
  activoExpandido &&
  vehiculoSeleccionado &&
  (
    moduloActivo === 'mapa' ||
    moduloActivo === 'vehiculos'
  ) && (
    <VehicleDetail
      vehiculoSeleccionado={
        vehiculoSeleccionado
      }

      setVehiculoSeleccionado={
        setVehiculoSeleccionado
      }

      onClose={() => {
        setActivoExpandido(false);
      }}
    />
  )}
{!isMobile && (
  <FolderTabsBar
    activeTab={folderTabActiva}
    setActiveTab={(tab) => {
      if (tab === 'historico') {
        setFolderTabActiva(null);

        setModuloActivo('historico');
        setModoHistorico(true);

        setModoCrearGeocerca(false);
        setGeocercaTemporal(null);
        setGeocercaSeleccionada(null);

        return;
      }

      setFolderTabActiva(tab);

      if (tab !== 'geocercas') {
        setModoCrearGeocerca(false);
        setGeocercaTemporal(null);
        setGeocercaSeleccionada(null);
      }

      if (moduloActivo !== 'vehiculos') {
        setModuloActivo('mapa');
      }

      setModoHistorico(false);
    }}
  />
)}
{(
  isMobile ||
  moduloActivo === 'mapa' ||
  moduloActivo === 'historico' ||
  (
    !isMobile &&
    (
      moduloActivo === 'vehiculos' ||
      moduloActivo === 'centinela'
    )
  )
) && (
          <>
<div style={{
  position: 'absolute',
  inset: 0,
  visibility: !isMobile || moduloActivo === 'mapa' || moduloActivo === 'historico'
    ? 'visible' : 'hidden',
  pointerEvents: !isMobile || moduloActivo === 'mapa' || moduloActivo === 'historico'
    ? 'auto' : 'none'
}}>
<GoogleMapView
  onDiviMapReady={() => setDiviMapaListo(true)}
  vehicles={vehicles}
  historialRuta={historialRuta}
  modoHistoricoActivo={
    moduloActivo === 'historico'
  }
  playbackIndex={playbackIndex}
  playbackPosition={playbackPosition}
  playbackTravelledPath={playbackTravelledPath}
    detencionesHistoricas={detencionesHistoricas}
  vehiculoSeleccionado={vehiculoSeleccionado}
  setVehiculoSeleccionado={setVehiculoSeleccionado}
  selectionToken={seleccionUbicacionToken}
  detalleVehiculoVisible={
  isMobile && activoExpandido
}

onOpenVehicleDetail={(vehiculo) => {
 

  if (!vehiculo) {
    return;
  }

  setVehiculoSeleccionado(vehiculo);
  setActivoExpandido(true);
}}

onOpenHistory={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setFolderTabActiva(null);

  setModuloActivo('historico');
  setModoHistorico(true);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);
}}

onOpenEvents={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setModuloActivo(isMobile ? 'eventos' : 'mapa');
  setFolderTabActiva(isMobile ? null : 'eventos');
  setActivoExpandido(false);

  setModoHistorico(false);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);
}}

onOpenGeofences={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setModuloActivo('mapa');
  setFolderTabActiva('geocercas');

  setModoHistorico(false);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);
}}

onOpenTracking={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setModuloActivo('mapa');
  setFolderTabActiva('rastreo');

  setModoHistorico(false);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);
}}

onOpenReports={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setModuloActivo('informes');
  setFolderTabActiva(null);
  setActivoExpandido(false);

  setModoHistorico(false);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);
}}

onOpenSentinel={() => {
  if (!vehiculoSeleccionado) {
    return;
  }

  setFolderTabActiva(null);
  setModoHistorico(false);

  setModoCrearGeocerca(false);
  setGeocercaTemporal(null);
  setGeocercaSeleccionada(null);

  setModuloActivo('centinela');
}}
ocultarMenuGeocercas={
    isMobile && folderTabActiva === 'geocercas'
  }
  modoCrearGeocerca={modoCrearGeocerca}
  geocercaTemporal={geocercaTemporal}
  setGeocercaTemporal={setGeocercaTemporal}
  geocercas={
    geocercaSeleccionada
      ? [geocercaSeleccionada]
      : []
  }
  radioGeocercaAmplia={
  folderTabActiva === 'geocercas' &&
  vistaGeocercas === 'geocercas'
}
/>
</div>

{!isMobile && (
  <VehicleDetail
    vehiculoSeleccionado={
      vehiculoSeleccionado
    }

    setVehiculoSeleccionado={
      setVehiculoSeleccionado
    }
  />
)}
          </>
        )}

        {moduloActivo === 'administracion' && (
          <AccountScopePage><AdministrationPage /></AccountScopePage>
        )}
        {moduloActivo === 'config' && (
  <AccountScopePage><ConfigurationPage /></AccountScopePage>
)}

{(
  moduloActivo === 'camaras'
) && (
  <NewModulePage
    module={moduloActivo}
    vehicles={vehicles}
    vehiculoSeleccionado={vehiculoSeleccionado}
    onClose={() => {
      setModuloActivo('mapa');
    }}
  />
)}
{moduloActivo === 'cuenta' && (
  <AccountScopePage><MyAccountPage
    onClose={() => setModuloActivo('mapa')}
    onOpenAdministration={() => setModuloActivo('administracion')}
    onOpenConfiguration={() => setModuloActivo('config')}
    onViewVehicles={() => {
      setModuloActivo('vehiculos');
    }}
  /></AccountScopePage>
)}
       {moduloActivo === 'control' && (
  <ControlPanel
    vehiculoSeleccionado={vehiculoSeleccionado}
    onClose={() => setModuloActivo('mapa')}
  />
)}
{moduloActivo === 'centinela' && (
  <CentinelaPanel
    onClose={() => setModuloActivo('mapa')}
    vehiculoSeleccionado={vehiculoSeleccionado}
    setVehiculoSeleccionado={setVehiculoSeleccionado}
  />
)}
{alertasCentinela.length > 0 && (
  <div
    style={{
      position: 'fixed',
      top: '78px',
      right: '22px',
      zIndex: 999999,
      width: '320px',
      borderRadius: '18px',
      padding: '16px',
      background:
        'linear-gradient(145deg, rgba(127,29,29,0.96), rgba(30,41,59,0.98))',
      border: '1px solid rgba(248,113,113,0.65)',
      boxShadow: '0 0 35px rgba(239,68,68,0.45)',
      color: '#fff'
    }}
  >
    <strong style={{ fontSize: '14px' }}>
      ⚠️ ALERTA CENTINELA
    </strong>

    <div style={{ marginTop: '10px' }}>
      <div style={{ fontWeight: 900 }}>
        {alertasCentinela[0].title}
      </div>

      <div style={{ fontSize: '12px', marginTop: '6px' }}>
        {alertasCentinela[0].message}
      </div>
    </div>

    <button
      onClick={() =>
        setAlertasCentinela((prev) => prev.slice(1))
      }
      style={{
        marginTop: '12px',
        width: '100%',
        height: '32px',
        borderRadius: '10px',
        border: '1px solid rgba(255,255,255,0.22)',
        background: 'rgba(255,255,255,0.12)',
        color: '#fff',
        fontWeight: 800,
        cursor: 'pointer'
      }}
    >
      ENTENDIDO
    </button>
  </div>
)}


{detalleNotificacion && (
  <div
    role="dialog"
    aria-label="Detalle de notificación"
    style={{
      position: 'fixed',
      left: isMobile ? 12 : 'auto',
      right: isMobile ? 12 : 24,
      bottom: isMobile
        ? 'calc(env(safe-area-inset-bottom, 0px) + 88px)'
        : 24,
      zIndex: 999998,
      width: isMobile ? 'auto' : 360,
      padding: 18,
      borderRadius: 20,
      color: '#ffffff',
      background:
        'linear-gradient(145deg, #102746, #071527)',
      border:
        '1px solid rgba(96,165,250,0.48)',
      boxShadow:
        '0 16px 45px rgba(2,8,23,0.48)'
    }}
  >
    <button
      type="button"
      aria-label="Cerrar detalle"
      onClick={() => setDetalleNotificacion(null)}
      style={{
        float: 'right',
        border: 0,
        background: 'transparent',
        color: '#ffffff',
        fontSize: 24,
        cursor: 'pointer'
      }}
    >
      ×
    </button>

    <div
      style={{
        color: '#60a5fa',
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: 1.2
      }}
    >
      ACTIVIDAD DEL VEHÍCULO
    </div>

    <h2
      style={{
        margin: '10px 0 6px',
        fontSize: 21
      }}
    >
      {detalleNotificacion.nombre}{' '}
      {detalleNotificacion.tipo === 'VEHICULO_ENCENDIDO'
        ? 'se encendió'
        : 'se apagó'}
    </h2>

    {detalleNotificacion.momento && (
      <p style={{ margin: '0 0 8px', color: '#cbd5e1' }}>
        {new Intl.DateTimeFormat('es-CO', {
          timeZone: 'America/Bogota',
          dateStyle: 'medium',
          timeStyle: 'short'
        }).format(
          new Date(detalleNotificacion.momento)
        )}
      </p>
    )}

    <p style={{ margin: '10px 0', color: '#e2e8f0' }}>
      {detalleNotificacion.mensaje || 'Actividad registrada.'}
    </p>
    {(detalleNotificacion.direccion || detalleNotificacion.ciudad) && (
      <p style={{ margin: '8px 0', color: '#cbd5e1' }}>
        {[detalleNotificacion.direccion, detalleNotificacion.ciudad]
          .filter(Boolean).join(', ')}
      </p>
    )}
  </div>
)}

{moduloActivo === 'historico' && (
  <HistoricalPlaybackV2
    vehiculoSeleccionado={vehiculoSeleccionado}
    monitorUserId={requestedScopeId}
    setHistorialRuta={setHistorialRuta}
    setPlaybackIndex={setPlaybackIndex}
    setPlaybackPosition={setPlaybackPosition}
    setPlaybackTravelledPath={setPlaybackTravelledPath}
    setDetencionesHistoricas={setDetencionesHistoricas}
    onClose={() => {
      setModoHistorico(false);
      setModuloActivo('mapa');
      setFolderTabActiva(null);
    }}
  />
)}
    {/*
<HistoricalPlayback
  abierto={
    modoHistorico || moduloActivo === 'historico'
  }
  setAbierto={setModoHistorico}
  setModuloActivo={setModuloActivo}
  vehiculoSeleccionado={vehiculoSeleccionado}
  historialRuta={historialRuta}
  setHistorialRuta={setHistorialRuta}
  playbackIndex={playbackIndex}
  setPlaybackIndex={setPlaybackIndex}
/>
*/}
      </AccountScopeProvider>
      </div>
    </div>
</>
  );
}

export default App;
